import * as React from 'react';
import { Table } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import {
  IAppointmentEmailDelivery,
  IAppointmentTextLog,
  IOfferEmailDelivery,
} from '@bb/domain/dist/types';

type DeliveryType = 'sms' | 'email';
type DataType = 'appointment' | 'offer';

type GeneralDeliveryLog =
  | IAppointmentEmailDelivery
  | IAppointmentTextLog
  | IOfferEmailDelivery;

type EmailLog = IAppointmentEmailDelivery | IOfferEmailDelivery;

type DeliveryLogState = {};

type DeliveryLogProps = {
  type: DeliveryType;
  dataType: DataType;
  deliveryLog: GeneralDeliveryLog[];
};

class DeliveryLog extends React.Component<DeliveryLogProps, DeliveryLogState> {
  constructor(props: DeliveryLogProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { deliveryLog, type, dataType } = this.props;
    return (
      <>
        {deliveryLog.length === 0 && (
          <div>
            No {type === 'email' ? 'email' : 'sms'} delivery logs for this{' '}
            {dataType}.
          </div>
        )}

        {deliveryLog.length > 0 && (
          <Table striped bordered>
            <thead>
              <tr>
                <th>Recipient</th>
                {type === 'sms' && <th>Mobile #</th>}
                <th>Event Type</th>
                <th>Status</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {type === 'email'
                ? deliveryLog
                    .sort(
                      (a: EmailLog, b: EmailLog) =>
                        new Date(b.receivedAt).getTime() -
                        new Date(a.receivedAt).getTime(),
                    )
                    .map((log: EmailLog) => (
                      <tr key={uuidv4()}>
                        <td>{log.recipient}</td>
                        <td>{log.emailType}</td>
                        <td>{log.event}</td>
                        <td>
                          {moment(log.receivedAt).format(
                            'MMM D, YYYY h:mm:ss a',
                          )}
                        </td>
                      </tr>
                    ))
                : deliveryLog
                    .sort(
                      (a: IAppointmentTextLog, b: IAppointmentTextLog) =>
                        new Date(b.statusLastUpdatedAt).getTime() -
                        new Date(a.statusLastUpdatedAt).getTime(),
                    )
                    .map((log: IAppointmentTextLog) => (
                      <tr key={uuidv4()}>
                        <td>
                          {`${log.contactFirstName} ${log.contactLastName}`}
                        </td>
                        <td>{log.to}</td>
                        <td>{log.messageType}</td>
                        <td>
                          {log.messageStatus}{' '}
                          {log.errorCode ? `(${log.errorCode})` : ''}
                        </td>
                        <td>
                          {moment(log.statusLastUpdatedAt).format(
                            'MMM D, Y h:mm:ss a',
                          )}
                        </td>
                      </tr>
                    ))}
            </tbody>
          </Table>
        )}
      </>
    );
  }
}

export default DeliveryLog;
